import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/summer-camp-shipping.jpg'),
    alt: 'summer camp shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'summer camp shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Summer Camp <span>Shipping</span> <span>Simplified with ShipAndStorage</span>',
  description:
    'Make summer camp preparation stress-free with ShipAndStorage! From packing to delivery, we handle it all so your camper can focus on making memories. ',
  image: {
    url: '/images/v2/pages/main-pages/summer-camp-shipping/hero-image.jpg',
    alt: 'snowboard-shipping'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Shipping Today' }
}

export const whyWeSectionContent = {
  title: 'How Summer Camp Shipping Works',
  description: 'We’ve streamlined the process to make summer camp logistics effortless.',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Ship in This Summer' },

  cards: [
    {
      id: 1,
      title: 'Book Online in Minutes',
      description: 'Schedule your shipment easily by selecting pick-up and delivery dates.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/book-online-in-minutes.svg',
        alt: 'Book Online in Minutes service'
      }
    },
    {
      id: 2,
      title: 'Pack and Label Your Items',
      description: 'Secure your camper’s belongings using durable containers, and attach the labels.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/pack-and-label-your-items.svg',
        alt: 'Pack and Label Your Items service'
      }
    },
    {
      id: 3,
      title: 'Pick-Up and Delivery',
      description: 'We’ll pick up items from your location and deliver them safely to the camp.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/pick-up-and-delivery.svg',
        alt: 'Pick-Up and Delivery service'
      }
    },
    {
      id: 4,
      title: 'Real-Time Tracking',
      description: 'Monitor your shipment every step of the way with our tracking tools.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/real-time-tracking.svg',
        alt: 'Real-Time Tracking service'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Choose ShipAndStorage for Summer Camp Shipping?',
  description: 'Our Summer Camp shipping service is designed to prioritize your camper’s comfort and convenience.',

  cards: [
    {
      id: 1,
      title: 'Expertise in Camp Logistics',
      description: 'We understand camp policies and ensure compliance with all guidelines.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/expertise-in-camp-logistics.svg',
        alt: 'Expertise in Camp Logistics service'
      }
    },
    {
      id: 2,
      title: 'Timely and Dependable Service',
      description: 'Your camper’s essentials will arrive on time, every time—no delays, no worries.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/timely-and-dependable-service.svg',
        alt: 'Timely and Dependable Service service'
      }
    },
    {
      id: 3,
      title: 'Secure Handling of Belongings',
      description: 'We treat every item with care, ensuring it arrives in perfect condition.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/secure-handling-of-belongings.svg',
        alt: 'Secure Handling of Belongings service'
      }
    },
    {
      id: 4,
      title: 'Affordable and Transparent Pricing',
      description: 'No hidden fees—just straightforward pricing that fits your budget.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/affordable-and-transparent-pricing.svg',
        alt: 'Affordable and Transparent Pricing service'
      }
    },
    {
      id: 5,
      title: 'Exceptional Customer Support',
      description: 'Our team is available 24/7 to assist with any questions or concerns.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/exceptional-customer-support.svg',
        alt: 'Exceptional Customer Support service'
      }
    },
    {
      id: 6,
      title: 'Hassle-Free Returns',
      description: 'Need items brought back home? We handle returns with the same efficiency.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/hassle-free-returns.svg',
        alt: 'Hassle-Free Returns service'
      }
    }
  ]
}

export const packingTipsSectionContent = {
  title: 'Packing Tips for Summer Camp Shipping',
  description: 'Packing smart is key to a smooth shipping experience. Follow these tips:',

  cards: [
    {
      id: 1,
      title: 'Use Sturdy Containers',
      description: 'Choose durable suitcases or boxes to protect items during transit.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/use-sturdy-containers.svg',
        alt: 'Use Sturdy Containers service'
      }
    },
    {
      id: 2,
      title: 'Label Everything Clearly',
      description: 'Add the camper’s name, camp address, and contact information on every item.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/label-everything-clearly.svg',
        alt: 'Label Everything Clearly service'
      }
    },
    {
      id: 3,
      title: 'Stick to the Essentials',
      description: "Use the camp's packing list to avoid overpacking and add all essential items.",
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/stick-to-the-essentials.svg',
        alt: 'Stick to the Essentials service'
      }
    },
    {
      id: 4,
      title: 'Protect Fragile Items',
      description: 'Wrap breakables in bubble wrap or padding to prevent damage in transit.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/protect-fragile-items.svg',
        alt: 'Protect Fragile Items service'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Storage Solutions for Campers',
  description: 'For campers needing storage before or after camp, we offer flexible, secure solutions.',

  cards: [
    {
      id: 1,
      title: 'Short-Term Storage',
      description:
        'Perfect for families needing secure and reliable storage during camp breaks, vacations, or short-term transitions.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/short-term-storage.svg',
        alt: 'Short-Term Storage service'
      }
    },
    {
      id: 2,
      title: 'Climate-Controlled Facilities',
      description:
        'Protect belongings from humidity, pests, and temperature changes in our well-maintained storage units.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/climate-controlled-facilities.svg',
        alt: 'Climate-Controlled Facilities service'
      }
    },
    {
      id: 3,
      title: '24/7 Security Monitoring',
      description: 'Our facilities feature continuous surveillance, ensuring the safety of your camper’s stored items.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/security-monitoring.svg',
        alt: '24/7 Security Monitoring service'
      }
    },
    {
      id: 4,
      title: 'Convenient Delivery Options',
      description:
        'Easily retrieve stored items with reliable and hassle-free delivery services tailored to your needs.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/convenient-delivery-options.svg',
        alt: 'Convenient Delivery Options service'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Prohibited Items',
  description: 'Certain items are restricted to ensure safety and compliance.',

  cards: [
    {
      id: 1,
      title: 'Pressurized Containers',
      description:
        'Sprays, perfumes, and pressurized cans pose safety risks during transit, making them unsuitable for shipping.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/pressurized-containers.svg',
        alt: 'Pressurized Containers'
      }
    },
    {
      id: 2,
      title: 'Tobacco Products',
      description:
        'Due to stringent legal regulations and restrictions, these items cannot be transported via shipping services.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/tobacco-products.svg',
        alt: 'Tobacco Products'
      }
    },
    {
      id: 3,
      title: 'Perishable Foods',
      description:
        'Items like fresh produce, dairy products, or meat can spoil during transit, compromising safety and quality.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/perishable-foods.svg',
        alt: 'Perishable Foods'
      }
    },
    {
      id: 4,
      title: 'Lithium Batteries',
      description:
        'Standalone batteries or those in devices are highly restricted due to potential fire hazards during transportation.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/lithium-batteries.svg',
        alt: 'Lithium Batteries'
      }
    },
    {
      id: 5,
      title: 'Fragile Items',
      description:
        'Delicate valuables like jewelry or glassware are vulnerable to loss or damage, making them unfit for shipping.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/fragile-items.svg',
        alt: 'Fragile Items'
      }
    },
    {
      id: 6,
      title: 'Hazardous Materials',
      description:
        'Flammable, toxic, or corrosive substances are prohibited to ensure the safety of shipments and transport personnel.',
      image: {
        src: '/images/v2/pages/main-pages/summer-camp-shipping/hazardous-materials.svg',
        alt: 'Hazardous Materials'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ready to Start Your Summer Camp Shipping?',
  description:
    'ShipAndStorage makes Summer Camp shipping stress-free, secure, and affordable. Whether you’re sending essentials or arranging post-camp storage, our reliable service is here to help.',
  image: {
    src: '/images/v2/pages/main-pages/summer-camp-shipping/promotional-banner-image.svg',
    alt: 'Ready to Start Your Summer Camp Shipping?'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Your Summer Camp' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'How early should I schedule my shipment?',
      answer: 'We recommend scheduling your shipment at least two weeks in advance for the best service.'
    },
    {
      id: 2,
      question: 'Can I ship directly to my camper’s dorm or cabin?',
      answer: 'Yes, but ensure the address complies with the camp’s shipping policies.'
    },
    {
      id: 3,
      question: 'What happens if I need to change my shipment dates?',
      answer: 'Contact our support team as soon as possible to adjust your shipping schedule.'
    },
    {
      id: 4,
      question: 'How do I track my shipment?',
      answer: "Use our real-time tracking tool available on our website for updates on your shipment's status."
    },
    {
      id: 5,
      question: 'Are there weight or size restrictions?',
      answer: 'Please check our guidelines for size and weight limits or contact us for clarification.'
    },
    {
      id: 6,
      question: 'Can I ship after camp ends?',
      answer: ' We offer return shipping services to bring items home.'
    }
  ]
}
